import ElementsBannerBlock from './elementsBannerBlock'

export default ElementsBannerBlock
